import React from "react";
import { ShareNetwork, InstagramLogo, YoutubeLogo } from "@phosphor-icons/react";

const linkClass = "border border-zinc-800 hover:border-[#FFD000] hover:text-[#FFD000] p-3 text-zinc-400 transition-colors block";

export const ShareRail = () => (
    <aside className="md:col-span-2 hidden md:block">
        <div className="sticky top-32 space-y-4">
            <div className="overline">Share</div>
            <button data-testid="share-button"
                onClick={() => navigator.clipboard?.writeText(window.location.href)}
                className={linkClass}>
                <ShareNetwork size={18} weight="bold" />
            </button>
            <a href="https://www.youtube.com/channel/UCK7IwwD0gvvompUwdg09GmA" target="_blank" rel="noreferrer" className={linkClass}>
                <YoutubeLogo size={18} weight="bold" />
            </a>
            <a href="https://www.instagram.com/tizonatech" target="_blank" rel="noreferrer" className={linkClass}>
                <InstagramLogo size={18} weight="bold" />
            </a>
        </div>
    </aside>
);
